import {
    SET_WHERE_FILTER,
    SET_KIND_FILTER,
    SET_DATE_FILTER,
    START_FILTERED_LOAD,
    SET_NEW_LIMIT,
    SET_KEYWORD_FILTER,
    SET_ALL_FILTERS
} from '../action-types';
import { getEmptyFilters } from '../../helpers/utils';

const initialState = getEmptyFilters();

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_ALL_FILTERS: {
            return { ...state, ...action.payload }
        }
        case SET_WHERE_FILTER: {
            const resVal = { ...state, ...{where: action.payload, start: 0 }}
            return resVal
        }
        case SET_KIND_FILTER: {
            return { ...state, ...{kind: action.payload, start: 0 }}
        }
        case SET_DATE_FILTER: {
            return { ...state, ...{date: action.payload, start: 0 }}
        }
        case SET_KEYWORD_FILTER: {
            return { ...state, ...{keyword: action.payload, start: 0 }}
        }
        case SET_NEW_LIMIT: {
            return { ...state, ...{start: action.payload }}
        }
        case START_FILTERED_LOAD: {
            return state;
        }
        default: {
          return state;
        }
    }
}
